import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuditLog } from 'falcon-api';

@Component({
  selector: 'app-audit-detail',
  templateUrl: './audit-detail.component.html',
  styleUrls: ['./audit-detail.component.scss']
})
export class AuditDetailComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { logEntry: AuditLog}
  ) { }

  ngOnInit(): void {
  }
}

